import { createContext, useContext, useState } from 'react'

export const useCreateToggleGroupContext = (initialValue?: string) => {
  const [value, setValue] = useState<string | undefined>(initialValue)

  return {
    value,
    setValue,
  }
}

export const toggleGroupContext = createContext<ReturnType<
  typeof useCreateToggleGroupContext
> | null>(null)

export const useToggleGroupContext = () => {
  const context = useContext(toggleGroupContext)
  if (!context) {
    throw new Error('toggleGroupContext must be used within its Provider.')
  }
  return context
}
